<template>
  <div>
    <Navigation />
    <div class="home-banner-three home-banner-four">
      <div class="home-slides-four owl-carousel owl-theme">
        <div class="home-item item-bg-1">
          <div class="d-table">
            <div class="d-table-cell">
              <div class="container">
                <div
                  class="main-banner-content main-banner-content-four text-center"
                >
                  <span>City Life Centre</span>
                  <p class="display-4 text-white"> ..become your best...</p>
                  <div class="banner-btn row">
                    <a href="/trauma-healing-centre" class="default-btn">
                      Trauma Healing Centre
                      <i class="flaticon-right"></i>
                      <span></span>
                    </a>
                    <a class="optional-btn" href="/business-leadership-institute">
                      Business and Leadership Institute
                      <i class="flaticon-right"></i>
                      <span></span>
                    </a>

                    <a class="optional-btn mt-4" href="/ipdyi">
                      International Purpose Driven Youth Initiatives
                      <i class="flaticon-right"></i>
                    </a>
                    <a class="optional-btn mt-4" href="/rhema-prophetic-centre">
                      Rhema Prophetic Centre
                      <i class="flaticon-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-item item-bg-2">
          <div class="d-table">
            <div class="d-table-cell">
              <div class="container">
                <div class="main-banner-content main-banner-content-four text-center">
                  <span style="font-family:verdana">Click the button below to Accept Jesus Christ as your lord and saviour</span>


                  <div class="banner-btn row">

                    <a
                        class="optional-btn"
                        href="#"
                        data-toggle="modal"
                        data-target="#faithModal"
                        style="color:white"
                        >Accept Jesus</a>

                    <a
                        class="optional-btn"
                        href="#"
                        data-toggle="modal"
                        data-target="#prayerRequestModal"
                        style="color:white"
                        >Prayer Request</a>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-item item-bg-3">
          <div class="d-table">
            <div class="d-table-cell">
              <div class="container">
                <div
                  class="main-banner-content main-banner-content-four text-center"
                >
                  <span style="font-family:verdana">Support the City Life Centre initiative</span>

                  <div class="banner-btn row">
                    <form
                            action="https://www.paypal.com/cgi-bin/webscr"
                            method="post"
                            target="_top"
                    >
                      <input type="hidden" name="cmd" value="_s-xclick" />
                      <input
                              type="hidden"
                              name="hosted_button_id"
                              value="JL2LZR54WMLZL"
                      />
                      <input
                              type="image"
                              src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
                              border="0"
                              class="p-4"
                              name="submit"
                              title="PayPal - The safer, easier way to pay online!"
                              alt="Donate with PayPal button"
                      />
                      <img
                              alt=""
                              border="0"
                              src="https://www.paypal.com/en_BW/i/scr/pixel.gif"
                              width="1"
                              height="1"
                      />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Home Banner Three Area -->

    <!-- Start Top Feature Area -->
    <section class="feature-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 p-0">
            <div class="feature-card">
              <div class="icon">
                <img src="assets/img/icon/1.png" alt="image" />
                <img src="assets/img/icon/white-1.png" alt="image" />
              </div>

              <h3>Vision</h3>
              <p>
                We see every member of our community become self-reliant, a
                purpose-driven change agent that is proactively involved in
                nation building, through holistic mentoring
                <!--                <span class="dots">...</span>-->
                <!--                <span class="more">-->
                <!--                  by raising a generation of people dedicated to community-->
                <!--                  service through spiritual development,educational-->
                <!--                  opportunities, economic empowerment and faith-based outreach-->
                <!--                </span>-->
              </p>
              <!--              <a-->
              <!--                href="#"-->
              <!--                @click="showMore"-->
              <!--                class="feature-btn myBtn"-->
              <!--                value="vision"-->
              <!--                >Read More</a-->
              <!--              >-->
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6 p-0">
            <div class="feature-card">
              <div class="icon">
                <img src="assets/img/icon/2.png" alt="image" />
                <img src="assets/img/icon/white-2.png" alt="image" />
              </div>

              <h3>Mission</h3>
              <p>
                The city life centre (CLC) seeks to provide for the society, in
                one complex, requisite environment that shall enable the
                individual acquire characteristics that will make for
                self-reliance, patriotism, nation building and peaceful
                coexistence.
              </p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6 p-0">
            <div class="feature-card">
              <div class="icon">
                <img src="assets/img/icon/3.png" alt="image" />
                <img src="assets/img/icon/white-3.png" alt="image" />
              </div>

              <h3>Objectives</h3>
              <p>
                The primary purpose of the city life centre (Botswana) is to
                raise motivated Christian leaders who will reach out and impact
                their communities with principles of the kingdom of God.
                <!--                <span class="dots2">...</span>-->
                <!--                <span class="more2">-->
                <!--                  that shall enable the individual acquire characteristics that-->
                <!--                  will make for patriotism, nation building and peaceful-->
                <!--                  coexistence through training on christian values-->
                <!--                  <p>-->
                <!--                    The center shall adopt Case Method Training (both formal and-->
                <!--                    informal)-->
                <!--                  </p>-->
                <!--                </span>-->
              </p>
              <!--              <a href="#" @click="showMore" class="feature-btn myBtn2"-->
              <!--                >Read More</a-->
              <!--              >-->
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6 p-0">
            <div class="feature-card">
              <div class="icon">
                <img src="assets/img/icon/4.png" alt="image" />
                <img src="assets/img/icon/white-4.png" alt="image" />
              </div>

              <h3>Arms of City Life Centre</h3>
              <ol>
                <li>Trauma Healing Program</li>
                <li>International Purpose Driven Youth Initiatives Program</li>
                <li>Business and Leadership program</li>
                <li>Rhema Prophetic Centre</li>

              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Top Feature Area -->

    <!-- Start Program Area -->
    <section class="donor-section pt-70 pb-70">
      <div class="section-title">
        <h2>Program Goals</h2>
      </div>
      <div class="container">
        <table class="table table-striped table-bordered table-dark">
          <thead>
            <tr>
              <th scope="col">Program</th>
              <th scope="col">Goal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Trauma Healing Centre</th>
              <td>
                <ol>
                  <li>
                    To facilitate permanent and holistic (emotional,
                    psychological, and spiritual) healing and wholeness of the
                    individual.
                  </li>
                </ol>
              </td>
            </tr>
            <tr>
              <th scope="row">
                International Purpose Driven Youth Initiatives
              </th>
              <td>
                <ol>
                  <li>
                    To help the youth clearly discover his\her person and
                    potentials
                  </li>
                  <li>maximally develop character and potentials</li>
                  <li>
                    Fully deploy potentials for fulfilment of his purpose as his
                    contribution to the fulfilment of the overall purpose of
                    mankind on earth
                  </li>
                </ol>
              </td>
            </tr>
            <tr>
              <th scope="row">Rhema Prophetic Centre</th>
              <td>
                <ol>
                  <li>
                    to help the individual to understand God’s love personally,
                    and to move into deep union with him
                  </li>
                  <li>
                    To help every believer become an effective minister of God
                    through discipleship training
                  </li>
                </ol>
              </td>
            </tr>
            <tr>
              <th scope="row">Business and Leadership Institute</th>
              <td>
                <ol>
                  <li>
                    To create space and programmes which allow case method
                    training of participants in the discipline of business
                    leadership and management driven by Christian values
                  </li>
                </ol>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- End Program Area -->

    <!-- Start Outreaches Area -->
    <section class="causes-section pt-100 pb-70">
      <div class="container">
        <div class="section-title">
          <span>
            <i class="flaticon-ribbon"></i>
            Our Outreaches
          </span>
          <h2>Program Outcomes & Benefits To The Community</h2>
        </div>

        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach1.jpg" alt="image" />

              <div class="causes-content">
                <h3>Trauma Healing: 2019</h3>
                <p>Training of 17 locals</p>
                <p>
                  Certified 14 Apprentice Facilitator & 3 ordinary participants
                </p>
                <p>Counselled over 100 locals</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach3.jpg" alt="image" />
              <div class="causes-content">
                <h3>Rhema Prophetic Centre</h3>
                <p>Weekly Tuesday and Friday Prayer Meetings</p>
                <p>Documented over 2000 Healing and Miracles</p>
                <p>
                  Produced Spiritual Testimony booklet to encourage sick and
                  oppressed
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach7.jpg" alt="image" />
              <div class="causes-content">
                <h3>Business and Leadership Institute</h3>
                <p>Monthly Finance and Business Seminars</p>
                <p>Networked start-up businesses with established Businesses</p>
                <p>Assisted in sourcing Investor for SPEDU</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach9.jpg" alt="image" />

              <div class="causes-content">
                <h3>Rhema Prophetic Centre</h3>
                <p>Non-denominational Prayer and Meditation</p>
                <p>Non-denominational Worship in Botswana</p>
                <p>Discipleship training for members and Local ministers</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach10.jpg" alt="image" />
              <div class="causes-content">
                <h3>International Purpose Driven Youth Initiatives</h3>
                <p>Registered with BUAN</p>
                <p>Inducted 30 Students in Feb, 2018</p>
                <p>About 700 members across Botswana</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-causes">
              <img src="assets/img/outreach/outreach11.jpg" alt="image" />
              <div class="causes-content">
                <h3>Orphan and Vulnerable Children & CLWD</h3>
                <p>Visit to BOGOGI SUPPORT GROUP</p>
                <p>Visit to “I AM SPECIAL Educational Society</p>
                <p>Visit BOMME LE BONTATE</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Causes Area -->

    <!-- Start Solve Area -->
    <section class="solve-section pb-70">
      <div class="container">
        <div class="section-title">
          <span>
            <i class="flaticon-to-do-list"></i>
            What We Do
          </span>
          <h2>A mission to solve problem</h2>
          <p>
            Raise motivated men and women of faith who will bear positive impact
            on the nation and the world at large.
          </p>
        </div>
      </div>
    </section>
    <!-- End Solve Area -->

    <div class="container text-center">
      <h5>
        If you would like to accept Jesus Christ as your Lord and savior
        please,<a
          href="#"
          class="btn btn-danger btn-sm mb-2"
          data-toggle="modal"
          data-target="#faithModal"
          >click here</a
        >
      </h5>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="faithModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Thank you for deciding to accept Jesus Christ as your Lord and
              Saviour. Please say this prayer below and mean it with all your
              heart.
            </p>
            <h6>Prayer of Salvation</h6>
            <p>
              Dear God, I thank you for loving me. I thank
              you for sending Jesus Christ to die for me. I thank you because he
              shed his blood on the cross of calvary to wash my sins away. With
              my heart I believe that he died and rose from the dead. With my
              mouth I confess that he is the Lord of my life. I accept the Holy
              Spirit into my life. I accept salvation and eternal life for my
              soul. I am born again. Thank you for answering me; I pray in Jesus
              name. Amen.
            </p>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeI9QcgYe0Aa2adK79o-QAzyy25PvvBySnXs4T0XK5hCzD2jQ/viewform?embedded=true" width="440" height="979" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            <div class="login-section ptb-100">
              <div class="container">
                <div class="login-form">
                  <div class="login-title">
                    <p>
                      If you said this prayer, kindly fill out this form as that
                      would enable us keep contact with you.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Prayer Request Modal -->
    <div class="modal fade" id="prayerRequestModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>Make your prayer request below.
            </p>
<!--            <iframe src="" width="640" height="975" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>-->
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeI9QcgYe0Aa2adK79o-QAzyy25PvvBySnXs4T0XK5hCzD2jQ/viewform?embedded=true" width="440" height="979" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            <div class="login-section ptb-100">
              <div class="container">
                <div class="login-form">

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Navigation from "./navBar/Navigation";
import Footer from "./Footer";

export default {
  name: "Home",
  components: {
    Navigation,
    Footer
  },
  methods: {
    showMore(e) {
      e.preventDefault();
      const dots = document.querySelector(".dots");
      const moreText = document.querySelector(".more");
      const btnText = document.querySelector(".myBtn");
      const dots2 = document.querySelector(".dots2");
      const moreText2 = document.querySelector(".more2");
      const btnText2 = document.querySelector(".myBtn2");

      if (e.target.className.includes("myBtn2")) {
        if (dots2.style.display === "none") {
          dots2.style.display = "inline";
          btnText2.innerHTML = "Read more";
          moreText2.style.display = "none";
        } else {
          dots2.style.display = "none";
          btnText2.innerHTML = "Read less";
          moreText2.style.display = "inline";
        }
      } else {
        if (dots.style.display === "none") {
          dots.style.display = "inline";
          btnText.innerHTML = "Read more";
          moreText.style.display = "none";
        } else {
          dots.style.display = "none";
          btnText.innerHTML = "Read less";
          moreText.style.display = "inline";
        }
      }
    }
  }
};
</script>

<style scoped></style>
